import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const KakaoRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showGuide, setShowGuide] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const isKakao = ua.includes('kakaotalk');
    const isAndroid = ua.includes('android');
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const fullUrl = window.location.href;
    const currentUrl = fullUrl.replace(/^https?:\/\//, '');

    if (!isKakao) {
      navigate('/home', { replace: true });
      return;
    }

    if (isIOS) {
      // 카카오톡 자체 외부 브라우저 열기 스킴 (Chrome 설치 여부 무관)
      window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(fullUrl)}`;

      // 스킴이 실패한 경우(구형 카카오톡 등) 안내 문구 표시
      setTimeout(() => setShowGuide(true), 1500);
    } else if (isAndroid) {
      window.location.href = `intent://${currentUrl}#Intent;scheme=https;package=com.android.chrome;end`;

      setTimeout(() => setShowGuide(true), 1500);
    }
  }, [navigate, location]);

  if (showGuide) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', height: '100vh', padding: '0 32px',
        textAlign: 'center', fontFamily: 'inherit',
      }}>
        <p style={{ fontSize: 16, fontWeight: 600, color: '#1a2a3a', marginBottom: 12 }}>
          외부 브라우저에서 열어주세요
        </p>
        <p style={{ fontSize: 14, color: '#6b7684', lineHeight: 1.7 }}>
          카카오톡 인앱 브라우저에서는 인증이 정상적으로 동작하지 않을 수 있습니다.{'\n'}
          우측 하단 <strong>···</strong> 메뉴 → <strong>기본 브라우저로 열기</strong>를 눌러주세요.
        </p>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', fontSize: 14, color: '#6b7684',
    }}>
      외부 브라우저로 이동 중입니다...
    </div>
  );
};

export default KakaoRedirect;
